<ng-container [caLocalizationScope]="localizationScope">
  <f-multiple-suggester
    [validation]="validation"
    [items]="securityStore.suggestions()"
    [selectedItems]="$any(securityStore.selectedItems())"
    [lazyLoadPredefinedSet]="false"
    [showPredefinedSet]="true"
    [customFilterMode]="true"
    [valuePath]="'name'"
    [idField]="'id'"
    [disabledPath]="'disabled'"
    [placeholder]="placeholder()"
    [minLength]="1"
    [actionsForAllList]="false"
    [actionsForCategories]="false"
    [categoryPath]="'category'"
    [resetScrollOnSearchChange]="true"
    (updateSearch)="securityStore.onSearchTextChange($event)"
    (select)="onSelect($any($event))"
    (selectMany)="onSelectMany($any($event))"
    (remove)="onRemove($any($event))"
    (removeMany)="onRemoveMany($any($event))"
    (reset)="securityStore.onSearchTextChange('')"
    (outclick)="securityStore.onSearchTextChange(''); outclick.emit()"
    (focus)="securityStore.onSearchTextChange(''); focus.emit()"
  >
    <ng-template #fSuggesterItemTemplate let-item="item" let-inputValue="inputValue">
      <ng-container
        *ngTemplateOutlet="suggesterItem; context: { $implicit: item, inputValue: inputValue }"
      ></ng-container>
    </ng-template>
  </f-multiple-suggester>
  @if(securityStore.selectedSecuritiesCount() > maxSelectionLimit()) {
  <div class="invalid-feedback d-block error-message-wrap">
    {{ 'maxLimitReachedError' | caLocalize : { count: maxSelectionLimit() } }}
  </div>
  }
  <ng-template #suggesterItem let-item let-inputValue="inputValue">
    <div
      class="d-flex justify-content-start enable-mouse-events"
      [title]="item.disabled ? ('maximumLimitReached' | caLocalize : { count: maxSelectionLimit() }) : item.name"
    >
      @if(item.type === suggesterItemType.Individual) {
      <span [title]="item.ticker" [innerHTML]="item.ticker | fHighlight : inputValue"></span>
      &nbsp;—&nbsp; }
      <span class="text-truncate" [innerHTML]="item.name | fHighlight : inputValue"></span>
      <i
        class="f-i f-i-star f-i-sm ps-1"
        [ngClass]="{
          'ca-default-security-list-icon': !item.disabled,
          'ca-default-security-list-icon-disabled': item.disabled
        }"
        data-automation-id="primary-list-icon"
        *ngIf="
          item.type === suggesterItemType.List &&
          primarySecurityListId() !== null &&
          primarySecurityListId() === item.id
        "
      ></i>
    </div>
    @let secondLine = item.type === suggesterItemType.Individual ? item.stockExchange! : item.itemsCount! + ' ' +
    ('securities' | caPluralize : item.itemsCount! | caLocalize);
    <div class="body-50 text-muted" [title]="secondLine">
      {{ secondLine }}
    </div>
  </ng-template>
</ng-container>
